var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.577,295.085a9,9,0,1,1,9,9A9.01,9.01,0,0,1,24.577,295.085Zm9,7.741a7.737,7.737,0,0,0,5.886-12.764l-10.739,11.05A7.7,7.7,0,0,0,33.577,302.826Zm-7.741-7.741a7.708,7.708,0,0,0,1.889,5.063l10.9-10.928a7.737,7.737,0,0,0-12.788,5.865Z",
    transform: "translate(-24.577 -286.085)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedWhite);
export default __webpack_public_path__ + "static/media/blocked-white.9eccdf48.svg";
export { ForwardRef as ReactComponent };